// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"79":"85f3a18c","178":"6a9af7f4","205":"6aee8e68","338":"a918d419","442":"6407ff1e","498":"860b87aa","513":"3a277327","651":"b3625594","703":"aa70bcaa","712":"fab732b4","729":"ef633e5c","772":"840f6c6e","879":"7452cbe4"}[chunkId] + ".chunk.js";
};